import React, { useState } from "react";
import axios from "axios";
import { SERVER_URL } from "../../config";
import "../../styles/messages.css";

interface MessageBoxProps {
  chatId: string;
  onMessageSent: () => void;
}

const MessageBox: React.FC<MessageBoxProps> = ({ chatId, onMessageSent }) => {
  const [inputMessage, setInputMessage] = useState<string>("");
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");
  const token = localStorage.getItem("token");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!inputMessage.trim()) return;
    setStatus("loading");
    try {
      const response = await axios.post(
        `${SERVER_URL}/api/message/messages`,
        { chatId, content: inputMessage },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Message sent successfully", response.data);
      setInputMessage("");
      setStatus("success");
      onMessageSent();
    } catch (error) {
      console.error("Error sending message:", error);
      setStatus("error");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="message-box-form">
      <textarea
        placeholder="Enter your message..."
        value={inputMessage}
        onChange={(e) => setInputMessage(e.target.value)}
        className="message-box-textarea"
        required
      ></textarea>
      <button type="submit" className="send-button">
        Send
      </button>
      {status === "error" && (
        <p className="error-message">Failed to send message.</p>
      )}
    </form>
  );
};

export default MessageBox;
